// pl_pms_reports.ts
// Tłumaczenia dla PMS.Reports – Live snapshot raportów operacyjnych

export const plPmsReports = {

  title: "Raporty",
  subtitle: "Raport operacyjny na żywo z systemu PMS.",

  // ── Wskaźniki ─────────────────────────────────────────────────────────────
  metrics: {
    occupancy:        "Obłożenie",
    reservations:     "Rezerwacje",
    checkedIn:        "Zameldowani",
    checkedOut:       "Wymeldowani",
    currentProperty:  "Bieżący obiekt",
    liveStatus:       "Status na żywo",
  },

  // ── Tabela główna ─────────────────────────────────────────────────────────
  primary: {
    title:              "Wyniki operacyjne",
    subtitle:           "Bieżąca aktywność hotelu.",
    arrivalsToday:      "Dzisiejsze przyjazdy",
    departuresToday:    "Dzisiejsze wyjazdy",
    totalCharges:       "Łącznie należności",
    totalPayments:      "Łącznie płatności",
    outstandingBalance: "Saldo do zapłaty",
  },

  // ── Tabela segmentów rynku ────────────────────────────────────────────────
  marketSegment: {
    title:            "Struktura segmentów rynku",
    subtitle:         "Rezerwacje wg segmentu rynku.",
    emptyLabel:       "Segmenty rynku",
    emptyValue:       "Brak danych",
    reservationCount: "{{count}} rezerwacja(e)",
  },

  // ── Tabela źródeł i pickup ────────────────────────────────────────────────
  sourcePickup: {
    title:              "Rezerwacje według źródła",
    subtitle:           "Rezerwacje wg źródła/kanału.",
    emptySourceLabel:   "Rezerwacje według źródła",
    emptySourceValue:   "Brak danych",
    reservationCount:   "{{count}} rezerwacja(e)",
  },

  pickup: {
    title:      "Nowe rezerwacje (7 dni)",
    subtitle:   "Rezerwacje utworzone dziennie w ostatnich 7 dniach.",
    emptyValue: "Brak danych",
  },

  meta: {
    generatedAt: "Wygenerowano",
  },

} as const;

export default plPmsReports;
